import {LoadingOverlay, Modal, Text, Title} from '@mantine/core'
import React, {useEffect, useState} from 'react'
import LoginQR from '../LoginQR'
import {collection, doc} from "firebase/firestore";
import {auth, firestore} from "../../firebase";
import {useFirestoreDocumentData} from "@react-query-firebase/firestore";
import {useAuthState} from "react-firebase-hooks/auth";

const ModalQRSelfie = ({setOpened, opened, subdomain}) => {

    const [user, userLoading] = useAuthState(auth);

    const [loading, setLoading] = useState(false);
    //!userData?.search
    const refAdmin = doc (collection(firestore, 'users'), user?.uid || "a");
    const userDoc = useFirestoreDocumentData(['users', user?.uid], refAdmin, {subscribe: true}, {});

    useEffect(() => {
        if (userDoc?.data?.search) {
            //setLoading(true);
            setTimeout(() => {
                setOpened(false);
            }, 5000)
        }
    }, [userDoc?.data?.search])
    useEffect(() => {
        const t = setInterval(() => {
            userDoc.refetch();
        }, 1000)
        return () => clearInterval(t);
    }, [])
    return (
    <Modal
        opened={opened}
        size="md"
        centered={true}
        withCloseButton={true}
        onClose={() => setOpened(false)}
        className="relative"
    >
        <div className="flex flex-col justify-center items-center">
            {loading && <LoadingOverlay visible={true}/>}
            <LoginQR size={200} path={subdomain || "dashboard"} />
            <Title align="center" style={{color:'#3c3c3c',marginTop:'1rem'}} order={3}>Scanează codul QR pe mobil</Title>
            <Text align="center" style={{color:'#3c3c3c',marginTop:'0.85rem',lineHeight:'22px'}}>Scanează codul QR cu telefonul mobil și urmarește instrucțiunile de pe ecran.</Text>
        </div>
    </Modal>
  )
}

export default ModalQRSelfie